<div class="dashboard w-full admin-compact-page">
  <app-breadcrumb></app-breadcrumb>
  <section class="module-landing-hero" aria-label="Role Management overview">
    <div class="module-landing-hero__content">
      <div class="module-landing-hero__eyebrow">ADMINISTRATION</div>
      <h1>Role Management</h1>
      <p>Maintain role definitions, user-type alignment, permissions governance, and role lifecycle actions from a streamlined administration page.</p>
    </div>
    <div class="module-landing-hero__chips">
      <div class="module-landing-hero__chip"><span>Total Roles</span><strong>{{ pagination.length || 0 }}</strong></div>
      <div class="module-landing-hero__chip"><span>Page Size</span><strong>{{ pagination.limit || 10 }}</strong></div>
      <div class="module-landing-hero__chip"><span>Governance</span><strong>Active</strong></div>
    </div>
  </section>

  <div class="admin-toolbar">
    <mat-form-field>
      <input
        matInput
        placeholder="Search roles"
        [formControl]="searchForm.get('search')"
        (keyup)="onSearch($event)"
      />
      <button mat-icon-button matSuffix aria-label="Search">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
    <span class="admin-toolbar__spacer"></span>
    <button
      [disabled]="!hasDetailedPerm('Role_Management', 'Create', 'read')"
      class="app-button"
      mat-flat-button
      (click)="createRole()"
    >
      <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
      <span class="ml-2 mr-1">Create Role</span>
    </button>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="serial">
        <th mat-header-cell *matHeaderCellDef class="text-center">Sr. No.</th>
        <td mat-cell *matCellDef="let role; let i = index" class="text-center">
          {{ i + 1 + pagination.page * pagination.limit }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Role Name</th>
        <td mat-cell *matCellDef="let role" class="max-w-[180px] truncate" [matTooltip]="role.name" matTooltipPosition="above">
          {{ role.name || '--' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="desc">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let role" class="max-w-[260px] truncate">{{ role.desc || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="userRoleType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>User Type</th>
        <td mat-cell *matCellDef="let role">{{ (role.userRoleType | titlecase) || '--' }}</td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
        <td mat-cell *matCellDef="let role">{{ role.metadata?.createdAt | date: "dd/MM/yyyy" }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Updated Date</th>
        <td mat-cell *matCellDef="let role">{{ role.metadata?.updatedAt | date: "dd/MM/yyyy" }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let role">
          <button mat-icon-button color="accent" (click)="viewDetail(role)" matTooltip="View" matTooltipPosition="above">
            <mat-icon>remove_red_eye</mat-icon>
          </button>
          <button
            [disabled]="!hasDetailedPerm('Role_Management', 'Edit', 'read')"
            mat-icon-button
            (click)="editRole(role)"
            matTooltip="Edit"
            matTooltipPosition="above"
          >
            <mat-icon>edit</mat-icon>
          </button>
          <span
            [matTooltip]="role.name === 'Vendor Default' ? 'This is a system-defined default role and cannot be deleted.' : 'Delete'"
            matTooltipPosition="above"
          >
            <button
              [disabled]="!hasDetailedPerm('Role_Management', 'Delete', 'read') || role.name === 'Vendor Default'"
              mat-icon-button
              (click)="deleteRole(role)"
            >
              <mat-icon class="app-text">delete</mat-icon>
            </button>
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell text-center py-10 text-gray-500" [attr.colspan]="displayedColumns.length">
          No roles found. Click 'Create Role' to add one.
        </td>
      </tr>
    </table>
    <div class="flex justify-end bg-white">
      <mat-paginator
        [length]="pagination.length"
        [pageSize]="10"
        [pageIndex]="pagination.page"
        [pageSizeOptions]="[5, 10, 25, 100]"
        (page)="onPaginateChange($event)"
      >
      </mat-paginator>
    </div>
  </div>
</div>
